/* eslint-disable */
import Popup from "reactjs-popup";
import { Button } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import Pagination from "../Pagination";
import { PUT, GET } from "../../../utils/HttpRequests";

export default function MessageLogs(props) {
  const reactUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    search_category: "",
    from: "",
    to: "",
    search_text: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(100);
  const [pageNo, setPageNumber] = useState(1);
  const [detail, setDetail] = useState({
    totalCount: 0,
    vmns: [],
  });

  const fetchMessages = async () => {
    try {
      setLoading(true);
      let url = `${reactUrl}admin/console/ivr/message?pageNo=${pageNo}&pageSize=${pageSize}`;
      Object.keys(formData).forEach((key) => {
        if (formData[key]) {
          if (key === "from" || key === "to") {
            url = `${url}&${key}=${moment(formData[key]).toISOString()}`;
          } else {
            url = `${url}&${key}=${formData[key]}`;
          }
        }
      });

      const res = await GET(url);
      console.log(res?.data?.response);
      setDetail({ ...detail, ...res?.data?.response });
      setLoading(false);
      setPageSize(100);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };

  const clearFilter = async () => {
    setFormData({
      search_category: "",
      from: "",
      to: "",
      search_text: "",
    });
    await fetchMessages();
  };

  useEffect(() => {
    fetchMessages();
  }, [pageNo]);

  const onChange = (e) => {
    console.log(e.target.id, e.target.value);
    setError("");
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  let messagesHTML;

  messagesHTML = loading
    ? null
    : detail.messages.map((message) => (
        <>
          <tr>
            <td>{message?.v_mobile_no ? message?.v_mobile_no : "-"}</td>
            <td>{message?.s_mobile_no ? message?.s_mobile_no : "-"}</td>
            <td>
              <span uib-tooltip="ReceivedAt">
                {message?.created_at
                  ? moment(message?.created_at).format("DD-MM-YYYY, h:mm:ss A")
                  : "-"}
              </span>
            </td>
            <td>{message?.label_keys ? message?.label_keys[0] : "-"}</td>
          </tr>
        </>
      ));
  return (
    <div
      style={{
        display: "flex",
        padding: "1%",
        justifyContent: "space-between",
        flexWrap: "wrap",
        boxShadow: "none",
      }}
    >
      <div>
        <h4 style={{ paddingRight: "2px" }}>
          Message Logs
          <a
            href="javascript:void(0)"
            style={{ paddingLeft: "5px" }}
            className="icon pls"
            uib-tooltip="Already allotted"
            ng-if="vmn.is_used"
          />
        </h4>
      </div>
      <div style={{ flexBasis: "100%" }}>
        <form className="form-horizontal">
          <div
            style={{ display: "flex", paddingRight: "10%", margin: "1% 0%" }}
          >
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="search_category"
                onChange={onChange}
                value={formData.search_category}
              >
                <option value="" selected="selected">
                  Select Column
                </option>
                <option value="v_mobile_no">VMN</option>
                <option value="s_mobile_no">Sender ID</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <input
                type="text"
                name="search_text"
                className="form-control"
                id="search_text"
                value={formData.search_text}
                placeholder="Search"
                onChange={onChange}
              />
            </div>
            <div className="inputs-fl-1" style={{ display: "flex" }}>
              <label style={{ paddingRight: "5%", margin: "1% 0%" }}>
                From{" "}
              </label>

              <input
                type="date"
                name="from"
                className="form-control"
                id="from"
                value={formData.from}
                placeholder="From"
                onChange={onChange}
              />
            </div>
            <div className="inputs-fl-1" style={{ display: "flex" }}>
              <label style={{ paddingRight: "5%", margin: "1% 0%" }}>To </label>

              <input
                type="date"
                name="to"
                className="form-control"
                id="to"
                value={formData.to}
                placeholder="From"
                onChange={onChange}
              />
            </div>

            <div style={{ display: "flex" }}>
              <Button
                variant="danger"
                onClick={fetchMessages}
                className="inputs-fl-1"
                style={{ marginRight: "5%" }}
              >
                Search
              </Button>
              <Button
                variant="danger"
                onClick={clearFilter}
                className="inputs-fl-1"
              >
                Clear
              </Button>
            </div>

            <div />
          </div>
        </form>
        <>
          <div className="table-responsive bn">
            <table className="table">
              <thead className="thad-dark">
                <tr>
                  <th>VMN</th>
                  <th>Sender Id</th>
                  <th>Received At</th>
                  <th>Label</th>
                </tr>
              </thead>
              <tbody>
                {messagesHTML}
                {error && <div style={{ color: "red" }}>{error}</div>}
              </tbody>
            </table>
          </div>
        </>
      </div>
      <Pagination
        currentPage={pageNo}
        totalPages={detail.totalPages + 1}
        setPageNumber={(page) => {
          setPageNumber(page);
        }}
      />
    </div>
  );
}
